import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable no-throw-literal */
export var KountSDKVersion = '2.0.0';
export default function kountSDK(config, sessionID) {
  var sdk = {
    KountSDKVersion: KountSDKVersion,
    kountClientID: null,
    isSinglePageApp: false,
    collectorURL: null,
    sessionID: null,
    kddcgid: null,
    FPCV_COOKIE_NAME: 'clientside-cookie',
    FPCV_LOCAL_STORAGE_KEY: 'clientside-local',
    FPCV_SESSION_STORAGE_KEY: 'kountCookie',
    SESSION_STORAGE_KEY_SESSION_ID: 'KountSessionID',
    collectBehaviorData: false,
    callbacks: {},
    error: [],
    isDebugEnabled: false,
    LOG_PREFIX: 'k:',
    serverConfig: null,
    orchestrateTimeoutId: null,
    updateSDKServerConfigTimeoutInMS: 3000,
    orchestrateSemaphoreLocked: false,
    start: function start(config, sessionID) {
      if (typeof config === 'undefined') {
        if (window.console && window.console.log) {
          console.log("".concat(this.LOG_PREFIX, "SDK Disabled: config required."));
        }

        return false;
      }

      this.isDebugEnabled = typeof config.isDebugEnabled !== 'undefined' && typeof config.isDebugEnabled === 'boolean' && config.isDebugEnabled;
      this.log("SDK isDebugEnabled=".concat(this.isDebugEnabled));
      this.log('SDK starting...');
      var configuredClientID = config.clientID;

      if (typeof configuredClientID === 'undefined' || configuredClientID.length === 0) {
        this.log('SDK Disabled: clientID required.');
        return false;
      }

      this.kountClientID = configuredClientID;

      if (typeof config.callbacks !== 'undefined') {
        this.callbacks = config.callbacks;
      }

      var hostname = this._getHostname(config);

      if (hostname == null) {
        this.log("SDK Disabled: unresolved hostname.");
        return false;
      }

      this.collectorURL = "https://".concat(hostname);
      this.log("collectorURL=".concat(this.collectorURL));
      var configuredIsSPA = config.isSinglePageApp;

      if (typeof configuredIsSPA === 'undefined' || configuredIsSPA !== true && configuredIsSPA !== false) {
        this.log("SDK Disabled: invalid isSinglePageApp:".concat(configuredIsSPA));
        return false;
      }

      this.isSinglePageApp = configuredIsSPA;
      this.log("isSinglePageApp=".concat(this.isSinglePageApp));

      if (typeof sessionID === 'undefined' || sessionID.length === 0) {
        this.log('SDK Disabled: sessionID required.');
        return false;
      }

      this.sessionID = sessionID;
      this.kddcgid = this._newKDDCGID();

      this._communicateLatestSessionData();

      this._orchestrate();

      this.log("SDK Version=".concat(this.KountSDKVersion));
      this.log('SDK started.');
      return true;
    },
    _orchestrate: function () {
      var _orchestrate2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(generateNewKDDCGID) {
        var functionName, thisFunctionOwnsSemaphoreLock, msg, msUntilNextOrchestrate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                functionName = "_orchestrate";
                thisFunctionOwnsSemaphoreLock = false;
                _context.prev = 2;

                if (!this.orchestrateSemaphoreLocked) {
                  _context.next = 6;
                  break;
                }

                this.log("".concat(functionName, " gated by semaphore. Skipping..."));
                return _context.abrupt("return");

              case 6:
                this.orchestrateSemaphoreLocked = true;
                thisFunctionOwnsSemaphoreLock = true;
                this.log("".concat(functionName, " start..."));

                if (generateNewKDDCGID) {
                  this.kddcgid = this._newKDDCGID();
                }

                _context.next = 12;
                return this._getServerConfig();

              case 12:
                this.serverConfig = _context.sent;

                if (this.serverConfig.collector.run) {
                  this.log("".concat(functionName, " runCollector start..."));
                  this.runCollector();
                  this.log("".concat(functionName, " runCollector end..."));
                } else {
                  this.log("".concat(functionName, " runCollector skipped..."));
                  this.callback('collect-begin', {
                    SessionID: this.sessionID,
                    KountClientID: this.kountClientID
                  });
                  this.callback('collect-end', {
                    SessionID: this.sessionID,
                    KountClientID: this.kountClientID
                  });
                }

                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](2);
                msg = "".concat(functionName, " unexpected error: ").concat(_context.t0);
                this.log(msg);
                this.addError(msg);

              case 21:
                _context.prev = 21;

                if (thisFunctionOwnsSemaphoreLock) {
                  _context.next = 24;
                  break;
                }

                return _context.abrupt("return");

              case 24:
                clearTimeout(this.orchestrateTimeoutId);
                this.log("".concat(functionName, " config:").concat(JSON.stringify(this.serverConfig)));
                msUntilNextOrchestrate = this.serverConfig.ttlms;
                this.orchestrateTimeoutId = setTimeout(this._orchestrate.bind(this, true), msUntilNextOrchestrate);
                this.log("".concat(functionName, " scheduled for ").concat(msUntilNextOrchestrate, " ms"));
                this.log("".concat(functionName, " end..."));
                this.orchestrateSemaphoreLocked = false;
                return _context.finish(21);

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 16, 21, 32]]);
      }));

      function _orchestrate(_x) {
        return _orchestrate2.apply(this, arguments);
      }

      return _orchestrate;
    }(),
    _wrapPromiseInTimeout: function _wrapPromiseInTimeout(msUntilTimeout, promise) {
      return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
          reject(new Error("Timeout after ".concat(msUntilTimeout, "ms.")));
        }, msUntilTimeout);
        promise.then(function (value) {
          clearTimeout(timer);
          resolve(value);
        }).catch(function (reason) {
          clearTimeout(timer);
          reject(reason);
        });
      });
    },
    _getServerConfig: function _getServerConfig() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var functionName, serverConfig, url, response, jsonConfig, msg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                functionName = "_getServerConfig";
                serverConfig = null;
                _context2.prev = 2;

                _this.log("".concat(functionName, " start..."));

                url = "".concat(_this.collectorURL, "/cs/config?m=").concat(_this.kountClientID, "&s=").concat(_this.sessionID, "&sv=").concat(_this.KountSDKVersion, "&kddcgid=").concat(_this.kddcgid);
                _context2.next = 7;
                return _this._wrapPromiseInTimeout(_this.updateSDKServerConfigTimeoutInMS, fetch(url));

              case 7:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 10;
                  break;
                }

                throw "response not ok: ".concat(response.status);

              case 10:
                _context2.next = 12;
                return response.json();

              case 12:
                jsonConfig = _context2.sent;
                serverConfig = _this._translateJSONToServerConfig(jsonConfig);
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](2);
                msg = "".concat(functionName, " error caught. e:").concat(_context2.t0);

                _this.log(msg);

                _this.addError(msg);

              case 21:
                _context2.prev = 21;

                if (serverConfig == null) {
                  serverConfig = {
                    ttlms: 900000,
                    collector: {
                      run: true,
                      featureFlags: {
                        app: true,
                        battery: true,
                        browser: true,
                        exp: true,
                        page: true,
                        ui: true
                      }
                    }
                  };
                }

                _this.log("".concat(functionName, " config: ").concat(JSON.stringify(serverConfig)));

                _this.log("".concat(functionName, " end..."));

                return _context2.abrupt("return", serverConfig);

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 16, 21, 27]]);
      }))();
    },
    _translateJSONToServerConfig: function _translateJSONToServerConfig(jsonConfig) {
      var ttlms = this._translateTTLMSConfig(jsonConfig);

      var collectorConfig = this._translateCollectorConfig(jsonConfig);

      return {
        ttlms: ttlms,
        collector: collectorConfig
      };
    },
    _translateTTLMSConfig: function _translateTTLMSConfig(jsonConfig) {
      if (typeof jsonConfig.ttlms !== "number") {
        return 900000;
      }

      return jsonConfig.ttlms;
    },
    _translateCollectorConfig: function _translateCollectorConfig(jsonConfig) {
      var functionName = "_translateCollectorConfig";
      var collectorConfig = null;

      try {
        this.log("".concat(functionName, " start..."));

        if (typeof jsonConfig.collection == 'undefined' || typeof jsonConfig.collection.feature_flags == 'undefined') {
          throw "invalid response JSON:".concat(JSON.stringify(jsonConfig));
        }

        if (typeof jsonConfig.collection.collect !== "boolean") {
          throw "collect is not boolean: ".concat(typeof collection.collect);
        }

        var runCollector = jsonConfig.collection.collect;

        if (runCollector) {
          var feature_flags = jsonConfig.collection.feature_flags;

          if (typeof feature_flags.app !== "boolean") {
            throw "app feature flag is not boolean: ".concat(typeof feature_flags.app);
          }

          if (typeof feature_flags.battery !== "boolean") {
            throw "battery feature flag is not boolean: ".concat(typeof feature_flags.battery);
          }

          if (typeof feature_flags.browser !== "boolean") {
            throw "browser feature flag is not boolean: ".concat(typeof feature_flags.browser);
          }

          if (typeof feature_flags.exp !== "boolean") {
            throw "exp feature flag is not boolean: ".concat(typeof feature_flags.exp);
          }

          if (typeof feature_flags.page !== "boolean") {
            throw "page feature flag is not boolean: ".concat(typeof feature_flags.page);
          }

          if (typeof feature_flags.ui !== "boolean") {
            throw "ui feature flag is not boolean: ".concat(typeof feature_flags.ui);
          }

          collectorConfig = {
            run: runCollector,
            featureFlags: jsonConfig.collection.feature_flags
          };
        } else {
          collectorConfig = {
            run: runCollector
          };
        }
      } catch (e) {
        var msg = "".concat(functionName, " error caught. e:").concat(e);
        this.log(msg);
        this.addError(msg);
      } finally {
        if (collectorConfig == null) {
          collectorConfig = {
            run: true,
            featureFlags: {
              app: true,
              battery: true,
              browser: true,
              exp: true,
              page: true,
              ui: true
            }
          };
        }

        ;
        this.log("".concat(functionName, " end..."));
        return collectorConfig;
      }
    },
    _newKDDCGID: function _newKDDCGID() {
      var newKDDCGID = "invalid";

      try {
        if (typeof crypto != 'undefined' && typeof crypto.randomUUID != 'undefined') {
          newKDDCGID = crypto.randomUUID();
        } else {
          var ALLOWED_CHARS = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-1234567890";
          var kddcgid = "";

          for (var loopCount = 0; loopCount < 36; loopCount++) {
            kddcgid += ALLOWED_CHARS.charAt(Math.floor(Math.random() * ALLOWED_CHARS.length));
          }

          newKDDCGID = kddcgid;
        }
      } catch (e) {
        this.log("_newKDDCGID error:".concat(e));
      } finally {
        this.log("SDK kddcgid=".concat(newKDDCGID));
      }

      return newKDDCGID;
    },
    _getHostname: function _getHostname(config) {
      var configuredHostname = config.hostname;

      if (typeof configuredHostname !== 'undefined') {
        if (this._isHostnameValid(configuredHostname)) {
          var _configuredEnvironment = config.environment;

          if (_configuredEnvironment) {
            this.log("warning:both 'environment':".concat(_configuredEnvironment, " and deprecated 'hostname':").concat(configuredHostname, " configs were specified. using hostname."));
          }

          return configuredHostname;
        }

        this.log("invalid configuredHostname:".concat(configuredHostname));
        return null;
      }

      var configuredEnvironment = config.environment;

      if (configuredEnvironment) {
        configuredEnvironment = configuredEnvironment.toUpperCase();
      }

      switch (configuredEnvironment) {
        case 'TEST':
          return "tst.kaptcha.com";

        case 'PROD':
          return "ssl.kaptcha.com";

        default:
          this.log("invalid configuredEnvironment:".concat(configuredEnvironment));
          return null;
      }

      ;
    },
    _isHostnameValid: function _isHostnameValid(hostname) {
      if (typeof hostname !== 'string') {
        this.log("Invalid hostname: not a string: ".concat(typeof hostname));
        return false;
      }

      if (hostname.length === 0) {
        this.log('Invalid hostname: length 0.');
        return false;
      }

      var regex = /^[a-zA-Z0-9.]*$/g;

      if (!regex.test(hostname)) {
        this.log("Invalid hostname:".concat(hostname));
        return false;
      }

      return true;
    },
    _communicateLatestSessionData: function _communicateLatestSessionData() {
      try {
        this.log('communicateLatestSessionData running...');
        var sessionIdInSessionStorage = sessionStorage.getItem(this.SESSION_STORAGE_KEY_SESSION_ID);

        if (sessionIdInSessionStorage === null) {
          this.postNewSession(this.sessionID);
        } else if (sessionIdInSessionStorage !== this.sessionID) {
          this.postChangeSession(this.sessionID, sessionIdInSessionStorage);
        }

        sessionStorage.setItem(this.SESSION_STORAGE_KEY_SESSION_ID, this.sessionID);
      } catch (e) {
        this.addError("communicateLatestSessionData error:".concat(e));
      } finally {
        this.log('communicateLatestSessionData ending...');
      }
    },
    postNewSession: function postNewSession(sessionID) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var url;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                try {
                  _this2.log('postNewSession running...');

                  url = "".concat(_this2.collectorURL, "/session/").concat(sessionID, "?kddcgid=").concat(_this2.kddcgid);

                  _this2._postToURL(url, 'postNewSession');
                } catch (e) {
                  _this2.addError("postNewSession error:".concat(e));
                } finally {
                  _this2.log('postNewSession ending...');
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    postChangeSession: function postChangeSession(sessionID, previousSessionID) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var url;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                try {
                  _this3.log("postChangeSession running: newSession: ".concat(sessionID, " prevSession: ").concat(previousSessionID));

                  url = "".concat(_this3.collectorURL, "/session/").concat(_this3.sessionID, "?previousSessionID=").concat(previousSessionID, "&kddcgid=").concat(_this3.kddcgid);

                  _this3._postToURL(url, 'postChangeSession');
                } catch (e) {
                  _this3.addError("postChangeSession error:".concat(e));
                } finally {
                  _this3.log('postChangeSession ending...');
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    _postToURL: function _postToURL(url, calledFromFunc) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var request;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this4.log("_postToURL:".concat(calledFromFunc, " running..."));

                request = new XMLHttpRequest();

                request.onreadystatechange = function () {
                  if (request.readyState === XMLHttpRequest.DONE) {
                    if (request.status === 200 || request.status === 201) {
                      _this4.log("".concat(calledFromFunc, " success."));
                    } else {
                      _this4.addError("".concat(calledFromFunc, " unknown response: ").concat(request.status));

                      _this4.log("".concat(_this4.error, ":unknown response - ").concat(request.status));
                    }
                  }
                };

                request.open('POST', url, true);
                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                request.setRequestHeader('client-id', _this4.kountClientID);
                request.send();
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                throw _context5.t0;

              case 13:
                _context5.prev = 13;

                _this4.log("_postToURL:".concat(calledFromFunc, " ending..."));

                return _context5.finish(13);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 10, 13, 16]]);
      }))();
    },
    getFPCVFromLocalStorage: function getFPCVFromLocalStorage() {
      try {
        this.log('getFPCVFromLocalStorage running...');
        var value = localStorage.getItem(this.FPCV_LOCAL_STORAGE_KEY);

        if (value == null) {
          return '';
        }

        return value;
      } catch (e) {
        this.addError("getFPCVFromLocalStorage: error".concat(e));
        return '';
      }
    },
    getFPCVFromCookie: function getFPCVFromCookie() {
      try {
        this.log('getFPCVFromCookie running...');
        var dc = decodeURIComponent(document.cookie);
        var cookieList = dc.split(';');
        var cookieValue = '';

        for (var i = 0; i < cookieList.length; i++) {
          var currentCookie = cookieList[i].trim();
          var elements = currentCookie.split('=');

          if (elements.length === 2) {
            if (elements[0] === this.FPCV_COOKIE_NAME) {
              var _elements = _slicedToArray(elements, 2);

              cookieValue = _elements[1];
              this.log("getFPCVFromCookie: found new first party cookie: ".concat(cookieValue));
              break;
            }
          }
        }

        if (cookieValue === '') {
          var regex = /(cdn[.][a-z]+[.][0-9]+[.]ka.ck)/g;

          for (var _i = 0; _i < cookieList.length; _i++) {
            var _currentCookie = cookieList[_i].trim();

            if (regex.test(_currentCookie) === true) {
              var _elements2 = _currentCookie.split('=');

              if (_elements2.length === 2) {
                var _elements3 = _slicedToArray(_elements2, 2);

                cookieValue = _elements3[1];
                this.log("getFPCVFromCookie: found old first party cookie: ".concat(cookieValue));
                this.storeFPCVInCookie(cookieValue);
                break;
              }
            }
          }
        }

        return cookieValue;
      } catch (e) {
        this.addError("getFPCVFromCookie error:".concat(e));
        return '';
      }
    },
    storeFPCVInLocalStore: function storeFPCVInLocalStore(value) {
      try {
        this.log('storeFPCVInLocalStore running...');
        localStorage.setItem(this.FPCV_LOCAL_STORAGE_KEY, value);
      } catch (e) {
        this.addError("storeFPCVInLocalStore error:".concat(e));
      } finally {
        this.log('storeFPCVInLocalStore ending...');
      }
    },
    storeFPCVInCookie: function storeFPCVInCookie(value) {
      try {
        this.log('storeFPCVInCookie running...');
        var expire = 365;
        var d = new Date();
        d.setTime(d.getTime() + expire * 24 * 60 * 60 * 1000);
        var expires = "expires=".concat(d.toUTCString());
        var attributes = '; SameSite=None; Secure';

        if (window.location.protocol !== 'https:') {
          attributes = '; SameSite=Lax';
        }

        document.cookie = "".concat(this.FPCV_COOKIE_NAME, "=").concat(value, ";").concat(expires, ";path=/").concat(attributes);
      } catch (e) {
        this.addError("storeFPCVInCookie error:".concat(e));
      } finally {
        this.log('storeFPCVInCookie ending...');
      }
    },
    storeFPCVInSession: function storeFPCVInSession(value) {
      try {
        this.log('storeFPCVInSession running...');
        sessionStorage.setItem(sdk.FPCV_SESSION_STORAGE_KEY, value);
      } catch (e) {
        this.addError("storeFPCVInSession error:".concat(e));
      }
    },
    coordinateFirstPartyCookieValues: function coordinateFirstPartyCookieValues() {
      this.log('coordinateFirstPartyCookieValues running...');
      var deducedFPCV = '';
      var fpcvFromCookie = this.getFPCVFromCookie();
      var fpcvFromLocalStorage = this.getFPCVFromLocalStorage();
      this.storeFPCVInSession('');

      if (fpcvFromCookie === '' && fpcvFromLocalStorage === '') {
        deducedFPCV = '';
      } else if (fpcvFromCookie !== '' && fpcvFromLocalStorage === '') {
        this.storeFPCVInLocalStore(fpcvFromCookie);
        deducedFPCV = fpcvFromCookie;
      } else if (fpcvFromLocalStorage !== '' && fpcvFromCookie === '') {
        this.storeFPCVInCookie(fpcvFromLocalStorage);
        deducedFPCV = fpcvFromLocalStorage;
      } else if (fpcvFromLocalStorage === fpcvFromCookie && fpcvFromLocalStorage !== '' && fpcvFromCookie !== '') {
        deducedFPCV = fpcvFromLocalStorage;
      } else if (fpcvFromLocalStorage !== fpcvFromCookie && fpcvFromLocalStorage !== '' && fpcvFromCookie !== '') {
        this.storeFPCVInCookie(fpcvFromLocalStorage);
        deducedFPCV = fpcvFromLocalStorage;
      }

      if (deducedFPCV === '') {
        this.establishNewFPCV();
      } else {
        this.communicateExistingFPCV(deducedFPCV);
      }
    },
    establishNewFPCV: function establishNewFPCV() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var url, response, json, firstPartyCookieValue;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.log('establishNewFPCV running...');

                url = "".concat(_this5.collectorURL, "/cs/generatecookie?m=").concat(_this5.kountClientID, "&s=").concat(_this5.sessionID, "&sv=").concat(_this5.KountSDKVersion, "&kddcgid=").concat(_this5.kddcgid);
                _context6.next = 5;
                return fetch(url);

              case 5:
                response = _context6.sent;
                _context6.next = 8;
                return response.json();

              case 8:
                json = _context6.sent;

                if (json.value.length > 0) {
                  firstPartyCookieValue = json.value;

                  _this5.storeFPCVInCookie(firstPartyCookieValue);

                  _this5.storeFPCVInLocalStore(firstPartyCookieValue);

                  _this5.storeFPCVInSession(firstPartyCookieValue);
                }

                _context6.next = 15;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);

                _this5.addError("establishNewFPCV error:".concat(_context6.t0));

              case 15:
                _context6.prev = 15;

                _this5.log('establishNewFPCV ending...');

                return _context6.finish(15);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 12, 15, 18]]);
      }))();
    },
    communicateExistingFPCV: function communicateExistingFPCV(value) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var url, payload, request;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                try {
                  _this6.log('communicateExistingFPCV running...');

                  url = "".concat(_this6.collectorURL, "/cs/storecookie");
                  payload = "m=".concat(_this6.kountClientID, "&s=").concat(_this6.sessionID, "&sv=").concat(_this6.KountSDKVersion, "&k=").concat(value, "&kddcgid=").concat(_this6.kddcgid);
                  request = new XMLHttpRequest();

                  request.onreadystatechange = function () {
                    if (request.readyState === 4 && request.status === 500) {
                      _this6.log('communicateExistingFPCV: invalid cookie');

                      sdk.establishNewFPCV();
                    }

                    if (request.readyState === 4 && request.status === 200) {
                      _this6.log('communicateExistingFPCV: valid cookie');

                      sdk.storeFPCVInSession(value);
                    }
                  };

                  request.open('POST', url, true);
                  request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                  request.send(payload);
                } catch (e) {
                  _this6.addError("communicateExistingFPCV error:".concat(e));
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    _createIframe: function _createIframe() {
      var _this7 = this;

      var functionName = "_createIframe";

      try {
        this.log("".concat(functionName, " running..."));
        var iframeId = 'ibody';
        var priorIframe = document.getElementById(iframeId);

        if (priorIframe !== null) {
          priorIframe.remove();
        }

        var queryString = "m=".concat(this.kountClientID, "&s=").concat(this.sessionID, "&sv=").concat(this.KountSDKVersion, "&kddcgid=").concat(this.kddcgid);
        var fragment = '';

        if (this.isDebugEnabled) {
          fragment = '#console';
        }

        var iframe = document.createElement('iframe');
        iframe.id = iframeId;
        iframe.style.border = '0px';
        iframe.style.height = '1px';
        iframe.style.width = '1px';
        iframe.style.position = 'absolute';
        iframe.src = "".concat(this.collectorURL, "/logo.htm?").concat(queryString).concat(fragment);
        document.getElementsByTagName('body')[0].appendChild(iframe);

        if (typeof this.callbacks !== 'undefined') {
          this.callback('collect-begin', {
            SessionID: this.sessionID,
            KountClientID: this.kountClientID
          });
        }

        if (window.postMessage !== 'undefined' && window.onmessage !== 'undefined') {
          var onMessageHandlerFunc = function onMessageHandlerFunc(event) {
            try {
              if (event.origin !== _this7.collectorURL) {
                _this7.log("window.onmessage doesn't handle event origin:[type:".concat(event.type, ", origin:").concat(event.origin, "]"));

                return;
              }

              if (!event.data) {
                throw new Error("window.onmessage event has missing event.data:[type:".concat(event.type, ", origin:").concat(event.origin, "]"));
              }

              var data = null;

              if (JSON) {
                data = JSON.parse(event.data);
              } else {
                data = eval(event.data);
              }

              if (!_this7.isSinglePageApp && data.event === 'collect-end') {
                _this7.detach(window, 'unload', _this7.unloadHandler);
              }

              if (!data) {
                throw new Error("window.onmessage event has missing data:[type:".concat(event.type, ", origin:").concat(event.origin, "]"));
              }

              if (!data.params) {
                throw new Error("window.onmessage event has missing data.params:[type:".concat(event.type, ", origin:").concat(event.origin, ", data:").concat(event.data, "]"));
              }

              var params = {};
              Object.keys(data.params).forEach(function (index) {
                if (Object.prototype.hasOwnProperty.call(data.params, index)) {
                  switch (index) {
                    case 's':
                      params.SessionID = data.params[index];
                      break;

                    case 'm':
                      params.KountClientID = data.params[index];
                      break;

                    default:
                      params[index] = data.params[index];
                  }
                }
              });

              _this7.callback(data.event, params);

              _this7.log("window.onmessage executed for event:[type:".concat(event.type, ", origin:").concat(event.origin, ", data:").concat(event.data, "]"));
            } catch (e) {
              _this7.log("window.onmessage encountered an error: ".concat(e));
            }
          };

          window.onmessage = onMessageHandlerFunc;

          if (!this.isSinglePageApp) {
            this.attach(window, 'unload', this.unloadHandler);
          }
        } else {
          window.setTimeout(function () {
            _this7.callback('collect-end', {
              SessionID: _this7.sessionID,
              KountClientID: _this7.kountClientID
            });
          }, 3000);
        }
      } catch (e) {
        this.addError("".concat(functionName, " error:").concat(e));
      } finally {
        this.log("".concat(functionName, " ending..."));
      }
    },
    runCollector: function runCollector() {
      var _this8 = this;

      var functionName = "runCollector";

      try {
        this.log("".concat(functionName, " running..."));
        this.coordinateFirstPartyCookieValues();

        var waitForFirstParty = function waitForFirstParty(timeoutInMS, intervalBetweenChecksInMS) {
          return new Promise(function (resolve, reject) {
            var checkForFirstParty = function checkForFirstParty() {
              if (sessionStorage.getItem(_this8.FPCV_SESSION_STORAGE_KEY) !== '') {
                _this8._createIframe();

                resolve();
              } else if ((timeoutInMS -= intervalBetweenChecksInMS) < 0) {
                reject();
              } else {
                setTimeout(checkForFirstParty, intervalBetweenChecksInMS);
              }
            };

            setTimeout(checkForFirstParty, intervalBetweenChecksInMS);
          });
        };

        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  waitForFirstParty(2000, 10).then(function () {
                    return _this8.log("".concat(functionName, ": Collection Initiated"));
                  }).catch(function () {
                    return _this8.log("".concat(functionName, ": Invalid/Missing First Party cookie"));
                  });

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }))();
      } catch (e) {
        this.addError("".concat(functionName, " error:").concat(e));
      } finally {
        this.log("".concat(functionName, " ending..."));
      }
    },
    AttachToForm: function AttachToForm(formID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
      this.log('AttachToForm running...');
      var decisionPointField = 'kountDecisionPointUUID';

      if (this.collectBehaviorData) {}

      this.log('AttachToForm: Attaching to form...');
      var form = document.getElementById(formID);

      if (options != null && options.has('CustomFieldName') && options.get('CustomFieldName').length > 0) {
        this.log("AttachToForm: Overriding decisionPointField name to: ".concat(options.get('CustomFieldName')));
        decisionPointField = options.get('CustomFieldName');
      }

      if (form != null) {
        if (typeof form[decisionPointField] === 'undefined') {
          var hiddenField = document.createElement('input');
          hiddenField.setAttribute('type', 'hidden');
          hiddenField.setAttribute('name', decisionPointField);
          hiddenField.setAttribute('value', this.sessionID);
          form.appendChild(hiddenField);
          this.log("AttachToForm: Field ".concat(decisionPointField, " NOT found.                     Created and attached to form with value: ").concat(this.sessionID));
        } else {
          this.log("AttachToForm: Field ".concat(decisionPointField, " found, setting value to: ").concat(this.sessionID));
          form[decisionPointField].setAttribute('value', this.sessionID);
        }

        this.log("AttachToForm: Attached to form successfully using ".concat(this.sessionID, "                 value in ").concat(decisionPointField, " hidden field."));
      } else {
        this.addError("AttachToForm: FormID: ".concat(formID, " is not valid. Skipping attachment to form and collection."));
      }
    },
    NewSession: function NewSession(sessionID) {
      if (typeof sessionID === 'undefined') {
        this.addError("NewSession: Invalid sessionID.  You must set the 'sessionID' for collection. Disabling Kount SDK");
      } else {
        this.log("NewSession: SessionID set to: ".concat(sessionID));
        sessionStorage.clear();
        this.sessionID = sessionID;

        this._communicateLatestSessionData();

        this._orchestrate(true);
      }
    },
    log: function log(message) {
      if (this.isDebugEnabled && window.console && window.console.debug) {
        console.debug("".concat(this.LOG_PREFIX).concat(message));
      }
    },
    addError: function addError(error) {
      this.error.push(error);
      this.log(error);
    },
    callback: function callback(event, params) {
      if (typeof this.callbacks[event] !== 'undefined') {
        var theCallback = this.callbacks[event];
        this.callbacks[event] = undefined;
        theCallback(params);
      }
    },
    unloadHandler: function unloadHandler(event) {
      var endpoint = 'fin';
      var formData = {
        n: 'collect-end',
        com: 'false',
        et: 0,
        s: this.sessionID,
        m: this.kountClientID
      };

      try {
        var http = this.getXMLHttpRequest(endpoint, 'POST');
        http.send(formData);
      } catch (e) {}
    },
    getXMLHttpRequest: function getXMLHttpRequest(endpoint, method) {
      var http = null;
      var esc = encodeURIComponent || escape;
      var url = "".concat(this.collectorURL, "/").concat(endpoint);

      if (window.XMLHttpRequest) {
        try {
          http = new window.XMLHttpRequest();
        } catch (e) {}

        if ('withCredentials' in http) {
          http.open(method, url, false);
        } else if (typeof window.XDomainRequest !== 'undefined') {
          http = new window.XDomainRequest();
          http.open(method, url);
        } else {
          http = null;
        }
      } else {
        http = null;
      }

      return {
        send: function send(data) {
          if (!http) {
            return;
          }

          http.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          var payload = '';
          Object.keys(data).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              payload += "&".concat(esc(key), "=").concat(esc(data[key]));
            }
          });
          payload = payload.substring(1);
          http.send(payload);
        }
      };
    },
    attach: function attachFunc() {
      if (typeof document.addEventListener !== 'undefined') {
        return function addEventListenerFunc(element, event, callback) {
          element.addEventListener(event, callback, false);
        };
      }

      if (typeof document.attachEvent !== 'undefined') {
        return function attachEventFunc(element, event, callback) {
          element.attachEvent("on".concat(event), callback);
        };
      }

      return function noOpFunc(element, event, callback) {};
    }(),
    detach: function detachFunc() {
      if (typeof document.removeEventListener !== 'undefined') {
        return function removeEventListenerFunc(element, event, listener) {
          element.removeEventListener(event, listener, false);
        };
      }

      if (typeof document.detachEvent !== 'undefined') {
        return function detachEventFunc(element, event, listener) {
          element.detach("on".concat(event), listener);
        };
      }

      return function noOpFunc(element, event, listener) {};
    }()
  };

  try {
    if (sdk.start(config, sessionID)) {
      return sdk;
    }
  } catch (e) {}

  return null;
}